import { render, staticRenderFns } from "./GoodSelect.vue?vue&type=template&id=bab3da6e&scoped=true"
import script from "./GoodSelect.vue?vue&type=script&lang=js"
export * from "./GoodSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab3da6e",
  null
  
)

export default component.exports